// A KPI tile with a label, primary value, and optional trend/hint line.
export default function StatCard({ label, value, hint, trend, icon, className = '' }) {
  const trendTone = trend == null ? '' : trend >= 0 ? 'up' : 'down';
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-card__head">
        <span className="stat-card__label">{label}</span>
        {icon ? <span className="stat-card__icon">{icon}</span> : null}
      </div>
      <div className="stat-card__value">{value}</div>
      {hint || trend != null ? (
        <div className="stat-card__foot">
          {trend != null ? (
            <span className={`stat-card__trend stat-card__trend--${trendTone}`}>
              {trend >= 0 ? '▲' : '▼'} {Math.abs(trend).toFixed(1)}%
            </span>
          ) : null}
          {hint ? <span className="stat-card__hint">{hint}</span> : null}
        </div>
      ) : null}
    </div>
  );
}
